/**
 * Vehicle Selector – API-powered cascading dropdowns
 * Data source: https://scsbiz.wearevisum.com/api/v1/years
 */
(function () {
  const API_BASE = 'https://scsbiz.wearevisum.com/api/v1/years';
  const PARAMS = 'type=normal&with_sales=yes';

  document.addEventListener('DOMContentLoaded', init);

  function init() {
    const yearSelect = document.getElementById('vehicle-year');
    const makeSelect = document.getElementById('vehicle-make');
    const modelSelect = document.getElementById('vehicle-model');
    const trimSelect = document.getElementById('vehicle-trim');
    const cabSelect = document.getElementById('vehicle-cab');
    const validationMessage = document.getElementById('vehicle-validation-message');
    const trimWrapper = document.getElementById('trim-wrapper');
    const cabWrapper = document.getElementById('cab-wrapper');
    let validationFrame = null;

    if (!yearSelect) return;

    // ── Cache for API responses ──
    let cachedData = null; // stores full response for year+make combo

    // ── Helpers ──
    function resetSelect(sel, placeholder) {
      sel.innerHTML = '<option value="">' + placeholder + '</option>';
      sel.disabled = true;
    }

    // ── Top Sellers list (same order as source site) ──
    var TOP_SELLERS = ['Ford', 'Ram', 'Chevrolet', 'GMC', 'Dodge', 'Toyota'];

    function populateSelect(sel, items, placeholder) {
      sel.innerHTML = '<option value="">' + placeholder + '</option>';
      items.forEach(function (item) {
        var opt = document.createElement('option');
        opt.value = item;
        opt.textContent = item;
        sel.appendChild(opt);
      });
      sel.disabled = items.length === 0;
    }

    function populateMakeSelect(sel, allMakes, placeholder) {
      sel.innerHTML = '<option value="">' + placeholder + '</option>';

      var topItems = [];
      var otherItems = [];

      allMakes.forEach(function (make) {
        if (TOP_SELLERS.indexOf(make) !== -1) {
          topItems.push(make);
        } else {
          otherItems.push(make);
        }
      });

      // Keep Top Sellers in original TOP_SELLERS order
      topItems.sort(function (a, b) {
        return TOP_SELLERS.indexOf(a) - TOP_SELLERS.indexOf(b);
      });

      if (topItems.length > 0) {
        var grp1 = document.createElement('optgroup');
        grp1.label = 'Top Sellers';
        topItems.forEach(function (make) {
          var opt = document.createElement('option');
          opt.value = make;
          opt.textContent = make;
          grp1.appendChild(opt);
        });
        sel.appendChild(grp1);
      }

      if (otherItems.length > 0) {
        var grp2 = document.createElement('optgroup');
        grp2.label = 'All Others';
        otherItems.forEach(function (make) {
          var opt = document.createElement('option');
          opt.value = make;
          opt.textContent = make;
          grp2.appendChild(opt);
        });
        sel.appendChild(grp2);
      }

      sel.disabled = allMakes.length === 0;
    }

    // ── Model Top Sellers count per make (matches source site config) ──
    var MODEL_TOP_COUNTS = {
      'Ford': 4,        // F-150, F-250, F-350, Ranger
      'Ram': 3,         // 1500, 2500, 3500
      'Chevrolet': 4,   // Silverado 1500, 2500 HD, 3500 HD, Colorado
      'GMC': 4,         // Sierra 1500, 2500 HD, 3500 HD, Canyon
      'Dodge': 3,       // Ram 1500, 2500, 3500
      'Toyota': 3       // Tundra, Tacoma, 4Runner
    };

    function populateModelSelect(sel, allModels, placeholder, make) {
      sel.innerHTML = '<option value="">' + placeholder + '</option>';

      if (allModels.length === 0) {
        sel.disabled = true;
        return;
      }

      var topCount = MODEL_TOP_COUNTS[make] || 0;

      // Only group if we have a config for this make AND enough models
      if (topCount > 0 && topCount < allModels.length) {
        var topModels = allModels.slice(0, topCount);
        var otherModels = allModels.slice(topCount);

        var grp1 = document.createElement('optgroup');
        grp1.label = 'Top Sellers';
        topModels.forEach(function (model) {
          var opt = document.createElement('option');
          opt.value = model;
          opt.textContent = model;
          grp1.appendChild(opt);
        });
        sel.appendChild(grp1);

        var grp2 = document.createElement('optgroup');
        grp2.label = 'All Others';
        otherModels.forEach(function (model) {
          var opt = document.createElement('option');
          opt.value = model;
          opt.textContent = model;
          grp2.appendChild(opt);
        });
        sel.appendChild(grp2);
      } else {
        // No config for this make → flat list
        allModels.forEach(function (model) {
          var opt = document.createElement('option');
          opt.value = model;
          opt.textContent = model;
          sel.appendChild(opt);
        });
      }

      sel.disabled = false;
    }

    function showLoading(sel) {
      sel.innerHTML = '<option value="">Loading...</option>';
      sel.disabled = true;
    }

    // ── Step 1: Load Years ──
    (function loadYears() {
      showLoading(yearSelect);
      fetch(API_BASE + '?' + PARAMS)
        .then(function (r) { return r.json(); })
        .then(function (data) {
          populateSelect(yearSelect, data.years || [], 'Select Year');
          // restore from URL params
          restoreFromURL();
        })
        .catch(function () {
          resetSelect(yearSelect, 'Error loading years');
        });
    })();

    // ── Year change → load Makes ──
    yearSelect.addEventListener('change', function () {
      var year = this.value;
      resetSelect(makeSelect, 'Select Make');
      resetSelect(modelSelect, 'Select Model');
      resetSelect(trimSelect, 'Select Submodel');
      resetSelect(cabSelect, 'Select Cab Size');
      if (trimWrapper) trimWrapper.style.display = 'none';
      if (cabWrapper) cabWrapper.style.display = 'none';
      cachedData = null;

      if (!year) { validateAndSyncSteps(); return; }

      showLoading(makeSelect);
      fetch(API_BASE + '?year=' + encodeURIComponent(year) + '&' + PARAMS)
        .then(function (r) { return r.json(); })
        .then(function (data) {
          populateMakeSelect(makeSelect, data.makes || [], 'Select Make');
          validateAndSyncSteps();
        })
        .catch(function () {
          resetSelect(makeSelect, 'Select Make');
          validateAndSyncSteps();
        });
    });

    // ── Make change → load Models (+ trims2 cached) ──
    makeSelect.addEventListener('change', function () {
      var make = this.value;
      var year = yearSelect.value;
      resetSelect(modelSelect, 'Select Model');
      resetSelect(trimSelect, 'Select Submodel');
      resetSelect(cabSelect, 'Select Cab Size');
      if (trimWrapper) trimWrapper.style.display = 'none';
      if (cabWrapper) cabWrapper.style.display = 'none';
      cachedData = null;

      if (!make) { validateAndSyncSteps(); return; }

      showLoading(modelSelect);
      fetch(API_BASE + '?year=' + encodeURIComponent(year) + '&make=' + encodeURIComponent(make) + '&' + PARAMS)
        .then(function (r) { return r.json(); })
        .then(function (data) {
          cachedData = data;
          var models = data.models ? Object.keys(data.models) : [];
          populateModelSelect(modelSelect, models, 'Select Model', make);
          validateAndSyncSteps();
        })
        .catch(function () {
          resetSelect(modelSelect, 'Select Model');
          validateAndSyncSteps();
        });
    });

    // ── Model change → show Trims from cached data ──
    modelSelect.addEventListener('change', function () {
      var model = this.value;
      resetSelect(trimSelect, 'Select Submodel');
      resetSelect(cabSelect, 'Select Cab Size');
      if (trimWrapper) trimWrapper.style.display = 'none';
      if (cabWrapper) cabWrapper.style.display = 'none';

      if (!model || !cachedData) { validateAndSyncSteps(); return; }

      var trims2 = cachedData.trims2 || {};
      var trimEntries = trims2[model] || [];

      if (trimEntries.length > 0) {
        // Extract unique trims
        var uniqueTrims = [];
        var seen = {};
        trimEntries.forEach(function (entry) {
          if (entry.trim && !seen[entry.trim]) {
            uniqueTrims.push(entry.trim);
            seen[entry.trim] = true;
          }
        });

        if (uniqueTrims.length > 0) {
          populateSelect(trimSelect, uniqueTrims, 'Select Submodel');
          if (trimWrapper) trimWrapper.style.display = 'block';
        }
      }

      validateAndSyncSteps();
    });

    // ── Trim change → show Cab Sizes from cached data ──
    trimSelect.addEventListener('change', function () {
      var trim = this.value;
      var model = modelSelect.value;
      resetSelect(cabSelect, 'Select Cab Size');
      if (cabWrapper) cabWrapper.style.display = 'none';

      if (!trim || !model || !cachedData) { validateAndSyncSteps(); return; }

      var trims2 = cachedData.trims2 || {};
      var trimEntries = trims2[model] || [];

      // Filter cab sizes for this trim
      var cabs = [];
      var seenCab = {};
      trimEntries.forEach(function (entry) {
        if (entry.trim === trim && entry.cab && entry.cab !== '' && !seenCab[entry.cab]) {
          cabs.push(entry.cab);
          seenCab[entry.cab] = true;
        }
      });

      if (cabs.length > 0) {
        populateSelect(cabSelect, cabs, 'Select Cab Size');
        if (cabWrapper) cabWrapper.style.display = 'block';
      }

      validateAndSyncSteps();
    });

    cabSelect.addEventListener('change', function () { validateAndSyncSteps(); });

    // ── Validation & Stepper Sync ──
    function runValidateAndSyncSteps() {
      var trimRequired = trimWrapper && trimWrapper.style.display !== 'none' && !trimSelect.disabled && trimSelect.options.length > 1;
      var cabRequired = cabWrapper && cabWrapper.style.display !== 'none' && !cabSelect.disabled && cabSelect.options.length > 1;

      var vehicleDone = yearSelect.value && makeSelect.value && modelSelect.value
        && (!trimRequired || trimSelect.value)
        && (!cabRequired || cabSelect.value);

      var searchScope = yearSelect.closest('.m-main-product--info, product-info') || document;
      var colorPicker = searchScope.querySelector('.product-color-picker');
      var setupPicker = searchScope.querySelector('.product-setup-picker');
      var colorSelected = colorPicker ? colorPicker.querySelector('input:checked') : true;
      var setupSelected = setupPicker ? setupPicker.querySelector('input:checked') : true;

      var allDone = vehicleDone && colorSelected && setupSelected;

      var step1 = document.getElementById('step-1-container');
      var step2 = document.getElementById('step-2-container');
      var step3 = document.getElementById('step-3-container');

      if (vehicleDone) {
        if (step1) step1.classList.add('completed');
        if (step2) step2.classList.add('active');
        if (validationMessage) validationMessage.style.display = 'none';
      } else {
        if (step1) step1.classList.remove('completed');
        if (step2) step2.classList.remove('active');
        if (step3) step3.classList.remove('active');
        if (validationMessage && yearSelect.value) validationMessage.style.display = 'block';
      }

      if (vehicleDone && colorSelected) {
        if (step2) step2.classList.add('completed');
        if (step3) step3.classList.add('active');
      } else {
        if (step2) step2.classList.remove('completed');
        if (step3) step3.classList.remove('active');
      }

      if (allDone) {
        if (step3) step3.classList.add('completed');
      } else {
        if (step3) step3.classList.remove('completed');
      }

      var atcButtons = searchScope.querySelectorAll('.m-add-to-cart');
      atcButtons.forEach(function (btn) {
        if (allDone) {
          btn.setAttribute('data-steps-complete', 'true');
          btn.style.opacity = '1';
        } else {
          btn.setAttribute('data-steps-complete', 'false');
          btn.style.opacity = '0.7';
        }
      });
    }

    function validateAndSyncSteps() {
      if (validationFrame) return;

      validationFrame = requestAnimationFrame(function () {
        validationFrame = null;
        runValidateAndSyncSteps();
      });
    }

    function isConfigurationComplete() {
      var trimRequired = trimWrapper && trimWrapper.style.display !== 'none' && !trimSelect.disabled && trimSelect.options.length > 1;
      var cabRequired = cabWrapper && cabWrapper.style.display !== 'none' && !cabSelect.disabled && cabSelect.options.length > 1;

      var vehicleDone = yearSelect.value && makeSelect.value && modelSelect.value
        && (!trimRequired || trimSelect.value)
        && (!cabRequired || cabSelect.value);

      var searchScope = yearSelect.closest('.m-main-product--info, product-info') || document;
      var colorPicker = searchScope.querySelector('.product-color-picker');
      var setupPicker = searchScope.querySelector('.product-setup-picker');
      var colorSelected = colorPicker ? colorPicker.querySelector('input:checked') : true;
      var setupSelected = setupPicker ? setupPicker.querySelector('input:checked') : true;
      return vehicleDone && colorSelected && setupSelected;
    }

    // ── Listen for Color and Setup changes ──
    document.addEventListener('change', function (e) {
      if (e.target.closest('.product-color-picker') || e.target.closest('.product-setup-picker')) {
        validateAndSyncSteps();
      }
    });

    // ── Feedback styles for incomplete vehicle selection ──
    (function injectFeedbackStyles() {
      if (document.getElementById('vehicle-selector-feedback-css')) return;
      var st = document.createElement('style');
      st.id = 'vehicle-selector-feedback-css';
      st.textContent =
        '.vehicle-field.vehicle-field--error select{border-color:#BE1B1B !important;box-shadow:0 0 0 2px rgba(190,27,27,.15);}' +
        '.vehicle-field--shake{animation:vsShake .4s ease;}' +
        '@keyframes vsShake{0%,100%{transform:translateX(0)}20%,60%{transform:translateX(-5px)}40%,80%{transform:translateX(5px)}}';
      (document.head || document.documentElement).appendChild(st);
    })();

    function clearFieldErrors() {
      var errs = document.querySelectorAll('.vehicle-field--error');
      for (var i = 0; i < errs.length; i++) errs[i].classList.remove('vehicle-field--error');
    }

    // Highlight every required-but-empty vehicle field; returns the first empty select.
    function highlightIncompleteVehicle() {
      clearFieldErrors();
      var trimRequired = trimWrapper && trimWrapper.style.display !== 'none' && !trimSelect.disabled && trimSelect.options.length > 1;
      var cabRequired = cabWrapper && cabWrapper.style.display !== 'none' && !cabSelect.disabled && cabSelect.options.length > 1;
      var checks = [
        { sel: yearSelect, need: true },
        { sel: makeSelect, need: true },
        { sel: modelSelect, need: true },
        { sel: trimSelect, need: trimRequired },
        { sel: cabSelect, need: cabRequired }
      ];
      var firstEmpty = null;
      checks.forEach(function (c) {
        if (c.need && c.sel && !c.sel.value) {
          var field = c.sel.closest('.vehicle-field');
          if (field) {
            field.classList.add('vehicle-field--error', 'vehicle-field--shake');
            setTimeout(function () { field.classList.remove('vehicle-field--shake'); }, 450);
          }
          if (!firstEmpty) firstEmpty = c.sel;
        }
      });
      if (validationMessage) {
        validationMessage.textContent = '⚠ Please select your vehicle (Year, Make & Model) before adding to cart.';
        validationMessage.style.display = 'block';
      }
      return firstEmpty;
    }

    // Clear the red highlight as soon as the customer fills a field.
    [yearSelect, makeSelect, modelSelect, trimSelect, cabSelect].forEach(function (s) {
      if (s) s.addEventListener('change', clearFieldErrors);
    });

    // The product-info scope that owns the vehicle stepper this script
    // instance is tracking. Other pages can have an unrelated, hidden
    // vehicle-selector elsewhere in the DOM (e.g. a quick-view modal for a
    // recommended product) — that must never gate an unrelated product's
    // own Add to Cart button, so every check below is scoped to this.
    var ownScope = yearSelect.closest('.m-main-product--info, product-info') || yearSelect.closest('.vehicle-config-stepper');

    // ── Intercept ATC clicks if steps aren't complete ──
    document.addEventListener('click', function (e) {
      var atcBtn = e.target.closest('.m-add-to-cart');
      if (!atcBtn) return;
      if (!ownScope || !ownScope.contains(atcBtn)) return;

      var isComplete = atcBtn.getAttribute('data-steps-complete') === 'true' || isConfigurationComplete();
      if (isComplete) return;

      // Not ready → block add and tell the customer exactly what to do.
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();

      var firstEmpty = highlightIncompleteVehicle();
      var target = document.querySelector('.vehicle-config-stepper') || document.getElementById('vehicle-selector-block');
      if (target) {
        var offset = 120;
        var top = target.getBoundingClientRect().top + window.pageYOffset - offset;
        window.scrollTo({ top: top, behavior: 'smooth' });
      }
      if (firstEmpty) {
        setTimeout(function () { try { firstEmpty.focus(); } catch (err) {} }, 400);
      }
    }, true);

    // ── URL Parameters handling ──
    function restoreFromURL() {
      var urlParams = new URLSearchParams(window.location.search);
      var pYear = urlParams.get('year');
      var pMake = urlParams.get('make');
      var pModel = urlParams.get('model');

      if (pYear) {
        yearSelect.value = pYear;
        yearSelect.dispatchEvent(new Event('change'));

        if (pMake) {
          // Wait for makes to load
          var makePoll = setInterval(function () {
            if (!makeSelect.disabled && makeSelect.options.length > 1) {
              clearInterval(makePoll);
              makeSelect.value = pMake;
              makeSelect.dispatchEvent(new Event('change'));

              if (pModel) {
                var modelPoll = setInterval(function () {
                  if (!modelSelect.disabled && modelSelect.options.length > 1) {
                    clearInterval(modelPoll);
                    modelSelect.value = pModel;
                    modelSelect.dispatchEvent(new Event('change'));
                  }
                }, 100);
                setTimeout(function () { clearInterval(modelPoll); }, 5000);
              }
            }
          }, 100);
          setTimeout(function () { clearInterval(makePoll); }, 5000);
        }
      }
    }

    // Initial check
    setTimeout(function () { validateAndSyncSteps(); }, 500);

    if (window.MinimogEvents) {
      MinimogEvents.subscribe(MinimogTheme.pubSubEvents.variantChange, function () {
        validateAndSyncSteps();
      });
    } else {
      document.addEventListener('variant:changed', function () {
        validateAndSyncSteps();
      });
    }
  }
})();
